export default __webpack_public_path__ + "static/media/icon-software-development.7f5df84f.svg";